export function showMarkerLabel(showLabel: number, usertitle: string, title: string): number {
	if (showLabel === 1 && usertitle) {
		return 1;
	} else if (showLabel === 2 && (usertitle || title)) {
		return 2;
	}

	return 0;
}
